import { createI18n } from 'vue-i18n'

const messages = {
  'zh-CN': {
    nav: {
      home: '热门商品',
      products: '首页',
      contact: '联系我们'
    },
    home: {
      bannerTitle: '发现优质好物',
      bannerSubtitle: '精选全球优质商品，品质生活从这里开始',
      explore: '探索商品',
      categories: '商品分类',
      featured: '精选推荐',
      viewAll: '查看全部',
      companyTitle: '关于我们',
      companyDesc1: '我们致力于为客户提供最优质的商品和服务。凭借多年的行业经验，我们建立了完善的供应链体系，确保每一件商品都经过严格筛选，满足客户的高标准需求。',
      companyDesc2: '从精选商品到贴心服务，我们始终坚持"客户至上"的理念，为全球客户提供卓越的购物体验。',
      companyLink: '了解更多'
    },
    products: {
      title: '商品列表',
      filter: '筛选',
      all: '全部商品',
      noProducts: '暂无商品',
      subtitle: '浏览我们精心挑选的优质商品，发现适合您的完美之选'
    },
    product: {
      detail: '商品详情',
      price: '价格',
      category: '分类',
      contact: '联系我们',
      inquiry: '立即询价',
      description: '商品介绍',
      summary: '摘要'
    },
    about: {
      title: '关于我们',
      subtitle: '了解我们的故事与愿景'
    },
    contact: {
      title: '联系我们',
      subtitle: '有任何问题？随时与我们联系',
      name: '您的姓名',
      email: '电子邮箱',
      phone: '联系电话',
      message: '留言内容',
      submit: '提交留言',
      success: '提交成功，我们会尽快与您联系！',
      info: '联系方式',
      labelPhone: '电话',
      labelEmail: '邮箱',
      labelAddress: '地址',
      addressValue: '中国上海市浦东新区陆家嘴金融贸易区',
      placeholderName: '请输入您的姓名',
      placeholderEmail: '请输入您的邮箱',
      placeholderPhone: '请输入您的电话',
      placeholderMessage: '请输入您的留言内容',
      alertSuccess: '感谢您的留言，我们会尽快与您联系！'
    },
    footer: {
      rights: '版权所有',
      follow: '关注我们'
    }
  },
  'zh-TW': {
    nav: {
      home: '熱門商品',
      products: '首頁',
      contact: '聯繫我們'
    },
    home: {
      bannerTitle: '發現優質好物',
      bannerSubtitle: '精選全球優質商品，品質生活從這裡開始',
      explore: '探索商品',
      categories: '商品分類',
      featured: '精選推薦',
      viewAll: '查看全部',
      companyTitle: '關於我',
      companyDesc1: '我們致力於為客戶提供最優質的商品和服務。藉多年的行業經驗，我們建立了完善的供應鏈體系，確保每一件商品都過嚴格篩選，足客戶的高標準需求。',
      companyDesc2: '從精選商品到貼心服務，我們始終堅持"客戶至上"的理念，為全球客戶提供卓越的購物體驗。',
      companyLink: '了解更多'
    },
    products: {
      title: '商品列表',
      filter: '篩選',
      all: '全部商品',
      noProducts: '暫無商品',
      subtitle: '覽我們精心挑選的優質商品，發現適合您的完美之選'
    },
    product: {
      detail: '商品詳情',
      price: '價格',
      category: '分類',
      contact: '聯繫我們',
      inquiry: '立即詢價',
      description: '商品介紹',
      summary: '摘要'
    },
    about: {
      title: '關於我們',
      subtitle: '了解我們的故事與願景'
    },
    contact: {
      title: '聯繫我們',
      subtitle: '有任何問題？隨時我聯繫',
      name: '您的姓名',
      email: '電子郵箱',
      phone: '聯繫電話',
      message: '留言內容',
      submit: '提交留言',
      success: '提交成功，我們會盡快與您繫！',
      info: '聯繫方式',
      labelPhone: '電話',
      labelEmail: '郵箱',
      labelAddress: '地址',
      addressValue: '中國上海市浦東新區陸家嘴金融易區',
      placeholderName: '請輸入您的姓名',
      placeholderEmail: '請輸入您的郵箱',
      placeholderPhone: '請輸入您的電話',
      placeholderMessage: '請輸入您的留言內容',
      alertSuccess: '感謝您的留言，我們會快與您聯繫！'
    },
    footer: {
      rights: '版權所有',
      follow: '關注我們'
    }
  },
  'en': {
    nav: {
      home: 'Hot Products',
      products: 'Home',
      contact: 'Contact'
    },
    home: {
      bannerTitle: 'Discover Quality Products',
      bannerSubtitle: 'Curated global quality products for a better life',
      explore: 'Explore Products',
      categories: 'Categories',
      featured: 'Featured Products',
      viewAll: 'View All',
      companyTitle: 'About Us',
      companyDesc1: 'We are committed to providing the best products and services. With years of industry experience, we have built a complete supply chain system to ensure every product is carefully selected.',
      companyDesc2: 'From curated products to thoughtful service, we always adhere to the "customer first" philosophy, providing an excellent shopping experience.',
      companyLink: 'Learn More'
    },
    products: {
      title: 'Products',
      filter: 'Filter',
      all: 'All Products',
      noProducts: 'No products available',
      subtitle: 'Browse our carefully selected products, discover the perfect choice for you'
    },
    product: {
      detail: 'Product Details',
      price: 'Price',
      category: 'Category',
      contact: 'Contact Us',
      inquiry: 'Inquire Now',
      description: 'Description',
      summary: 'Summary'
    },
    about: {
      title: 'About Us',
      subtitle: 'Learn our story and vision'
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'Have any questions? Get in touch with us',
      name: 'Your Name',
      email: 'Email',
      phone: 'Phone',
      message: 'Message',
      submit: 'Submit',
      success: 'Submitted successfully, we will contact you soon!',
      info: 'Contact Information',
      labelPhone: 'Phone',
      labelEmail: 'Email',
      labelAddress: 'Address',
      addressValue: 'Lujiazui Financial District, Pudong New Area, Shanghai, China',
      placeholderName: 'Please enter your name',
      placeholderEmail: 'Please enter your email',
      placeholderPhone: 'Please enter your phone',
      placeholderMessage: 'Please enter your message',
      alertSuccess: 'Thank you for your message, we will contact you soon!'
    },
    footer: {
      rights: 'All Rights Reserved',
      follow: 'Follow Us'
    }
  },
  'ru': {
    nav: {
      home: 'Популярные',
      products: 'Главная',
      contact: 'Контакты'
    },
    home: {
      bannerTitle: 'Откройте для себя качественные товары',
      bannerSubtitle: 'Отборные товары со всего мира для лучшей жизни',
      explore: 'Исследовать',
      categories: 'Категории',
      featured: 'Рекомендуемые',
      viewAll: 'Смотреть все',
      companyTitle: 'О нас',
      companyDesc1: 'Мы стремимся предоставить клиентам лучшие товары и услуги. Благодаря многолетнему опыту в отрасли, мы создали полную систему цепочки поставок, чтобы каждый продукт был тщательно отобран.',
      companyDesc2: 'От отборных товаров до продуманного обслуживания мы всегда придерживаемся философии "клиент прежде всего", предоставляя превосходный опыт покупок.',
      companyLink: 'Узнать больше'
    },
    products: {
      title: 'Товары',
      filter: 'Фильтр',
      all: 'Все товары',
      noProducts: 'Товары отсутствуют',
      subtitle: 'Просмотрите наш тщательно подобранный ассортимент, найдите идеальный выбор для себя'
    },
    product: {
      detail: 'Подробности',
      price: 'Цена',
      category: 'Категория',
      contact: 'Связаться',
      inquiry: 'Запросить цену',
      description: 'Описание',
      summary: 'Краткое содержание'
    },
    about: {
      title: 'О нас',
      subtitle: 'Узнайте нашу историю и видение'
    },
    contact: {
      title: 'Контакты',
      subtitle: 'Есть вопросы? Свяжитесь с нами',
      name: 'Ваше имя',
      email: 'Эл. почта',
      phone: 'Телефон',
      message: 'Сообщение',
      submit: 'Отправить',
      success: 'Успешно отправлено, мы скоро свяжемся с вами!',
      info: 'Контактная информация',
      labelPhone: 'Телефон',
      labelEmail: 'Email',
      labelAddress: 'Адрес',
      addressValue: 'Финансовый район Луцзяцзуй, Пудун, Шанхай, Китай',
      placeholderName: 'Введите ваше имя',
      placeholderEmail: 'Введите ваш email',
      placeholderPhone: 'Введите ваш телефон',
      placeholderMessage: 'Введите ваше сообщение',
      alertSuccess: 'Спасибо за ваше сообщение, мы скоро свяжемся с вами!'
    },
    footer: {
      rights: 'Все права защищены',
      follow: 'Подписывайтесь'
    }
  }
}

const i18n = createI18n({
  legacy: false,
  locale: 'ru',
  fallbackLocale: 'en',
  messages
})

export default i18n
